import gql from 'graphql-tag';

export const CREATE_BULK_QUIZZ = gql`
  mutation CreateMultipleQuestion($input: MultipleQuestionsInput!) {
    createMultipleQuestion(input: $input)
  }
`;
export const CREATE_QUIZZ = gql`
  mutation CreateQuestion($input: QuestionInput!) {
    createQuestion(input: $input) {
      _id
    }
  }
`;
export const UPDATE_QUIZZ = gql`
  mutation Mutation($updateQuestionId: MOID!, $input: QuestionInput!) {
    updateQuestion(id: $updateQuestionId, input: $input)
  }
`;

export const REMOVE_QUIZZ = gql`
  mutation RemoveQuestion($removeQuestionId: MOID!) {
    removeQuestion(id: $removeQuestionId)
  }
`;
